module.exports = __webpack_public_path__ + "img/2019四校戦.d62ddd0c.jpg";